import { BRAND_STATUS_V2 } from './common';
import { BrandsFindResponseBodyBrandDto } from '../api/brands';

export class BrandItemV2 {
  id: number;
  imageUrl: string;
  name: string;
  status: BRAND_STATUS_V2;
  createDate: string;
  tier?: number;
  no?: number;
  likeCount: number;
  activeProductCount: number;

  constructor(item: BrandsFindResponseBodyBrandDto) {
    this.id = item.id;
    this.name = item.name;
    this.imageUrl = item.mainImageUrl;
    this.status = item.status;
    this.createDate = item.createDate;
    this.tier = item.brandTier?.tier;
    this.no = item.brandTier?.no;
    this.likeCount = item.likeCount;
    this.activeProductCount = item.activeProductCount;
  }
}

export type BrandListRequest = {
  page?: number;
  pageSize?: number;
  id?: number;
  name?: string;
  status?: BRAND_STATUS_V2;
};

//클라이언트 옵션 -> 서버에 맞게 가공
export class BrandListRequestOption {
  page?: number;
  pageSize?: number;
  brandId?: number;
  brandName?: string;
  status?: BRAND_STATUS_V2;

  constructor(option: BrandListRequest) {
    this.page = option.page;
    this.pageSize = option.pageSize;
    this.brandId = option.id;
    this.brandName = option.name;
    this.status = option.status;
  }
}
